export const removeEmptyStringFields = (obj) => {
    var newObj = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value !== "") newObj[key] = value;
    }

    return newObj;
};
